import { useTranslation } from "react-i18next";
import { Navbar, Container, Row, Col, Nav, Image, Modal, Button } from "react-bootstrap";
import NavDropdown from 'react-bootstrap/NavDropdown';
import { BsMoon, BsSun } from "react-icons/bs";
import Cookies from "js-cookie";
import Lebenslauf from './img/Yevhenii-Airapetian-Lebenslauf-DE.pdf';
import CV from './img/Yevhenii-Airapetian-CV-EN.pdf';
import '../../../src/App.css';
import { ScrollToAnchor } from "../scroll-to-anchor/scroll-to-anchor";
import { useState, useEffect } from "react";
import useDarkMode from "./../../hooks/useDarkMode";
import navigationCSS from './css/navigation.css';
import { Link } from "react-router-dom";
import $ from 'jquery';
import { faGlobe, faBell, faVolumeXmark, faVolumeHigh, faDesktop, faPersonRunning, faCircleInfo, faBolt, faSun, faMoon } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useSound from 'use-sound';
import Click from './src/click.wav';
import { useSoundSettings } from './../soundContext/soundContext';
import { useLocation } from "react-router-dom";

export const NavigationBar = () => {

	const ClickMenuPrimaryLinks = () => {

		const [play] = useSound(Click);
		const { soundsEnabled } = useSoundSettings();
		return (
			<>
				<Nav.Link className={location.pathname === '/' ? 'text-light pe-4 active' : 'text-light pe-4'} onClick={() => { if (soundsEnabled) { play() }; setExpanded(false) }} as={Link} to='/'>
					{t("menu.aboutMenu")}
				</Nav.Link>
				<Nav.Link className={location.pathname === '/projects' ? 'text-light pe-4 active' : 'text-light pe-4'} onClick={() => { if (soundsEnabled) { play() }; setExpanded(false) }} as={Link} to='/projects'>
					{t("menu.projectsMenu")}

				</Nav.Link>

			</>
		)
	}

	const ClickMenuAdditionalLinks = () => {

		const [play] = useSound(Click);
		const { soundsEnabled } = useSoundSettings();
		return (
			<>
				<Nav.Link className={location.pathname === '/testimonials' ? 'text-light pe-4 active' : 'text-light pe-4'} onClick={() => { if (soundsEnabled) { play() }; setExpanded(false) }} as={Link} to='/testimonials'>
					{t("menu.testimonialsMenu")}
				</Nav.Link>
				<Nav.Link className={location.pathname === '/contact' ? 'text-light pe-4 active' : 'text-light pe-4'} onClick={() => { if (soundsEnabled) { play() }; setExpanded(false) }} as={Link} to='/contact'>
					{t("menu.contactMenu")}
				</Nav.Link>
				{/* <Nav.Link className={location.pathname === '/blog' ? 'text-light pe-4 active' : 'text-light pe-4'} onClick={() => { if (soundsEnabled) { play() }; setExpanded(false) }} as={Link} to='/blog'>
					{t("menu.blogMenu")}
				</Nav.Link> */}

			</>
		)
	}




	const ClickButton = () => {

		const [play] = useSound(Click);
		const { soundsEnabled } = useSoundSettings();
		return <Button className="info-sound-click-button" onClick={() => { if (soundsEnabled) { play() }; setVisible(!visible) }}>
		</Button>;
	}

	const SoundToggleButton = () => {
		const [play] = useSound(Click);
		const { soundsEnabled, toggleSounds } = useSoundSettings(); return (<Button className="mute-button fixed-ltr" onClick={toggleSounds}> {soundsEnabled ? <FontAwesomeIcon className="sound-tgl-icon" onClick={() => { handleShowSoundEnabledModal() }} title={t("muteAppTitle")} icon={faVolumeHigh} style={{ color: "#fff", }} size="lg" /> : <FontAwesomeIcon className="sound-tgl-icon" onClick={() => { if (soundsEnabled) { }; play(); handleShowSoundDisabledModal(); }} title={t("unmuteAppTitle")} icon={faVolumeXmark} style={{ color: "#fff", }} size="lg" />} </Button>);
	}

	const Themes = () => {
		const { soundsEnabled } = useSoundSettings();

		const [play] = useSound(Click);
		return <div className="choose-theme-div" title={t("themeTitle")}>

			<NavDropdown onClick={() => { if (soundsEnabled) { play() } }} className="pl-2 theme-drop cases-nav-container theme-options-nav-container" title="🌓" id="collapsible-nav-dropdown">



				<NavDropdown.Item className="themes-links">
					<ClickThemeDark />
				</NavDropdown.Item>
				<NavDropdown.Item className="themes-links">
					<ClickThemeLight />
				</NavDropdown.Item>
				<NavDropdown.Item className="themes-links">
					<ClickThemeOld />
				</NavDropdown.Item>
				<NavDropdown.Item className="themes-links">
					<ClickThemeReducedMotion />
				</NavDropdown.Item>
				<NavDropdown.Item className="themes-links">
					<ClickThemeSystem />
				</NavDropdown.Item>

			</NavDropdown>
		</div>
	};

	const ClickCases = () => {
		const [play] = useSound(Click);
		const { soundsEnabled } = useSoundSettings();

		return (
			<NavDropdown onClick={() => { if (soundsEnabled) { play() } }} className="cases-nav-container mr-2" title={t("menu.casesMenu")} id="collapsible-nav-dropdown">



				<NavDropdown.Item target="_self" alt="">
					<Link onClick={() => { if (soundsEnabled) { play() }; setExpanded(false) }} to="./../r3play-case" className="nav-cases" target="_self" >{t("menu.r3playMenu")}</Link>
				</NavDropdown.Item>
				<NavDropdown.Item target="_self" alt="">
					<Link onClick={() => { if (soundsEnabled) { play() }; setExpanded(false) }} to="./../myFlix-case" className="nav-cases" target="_self" >{t("menu.myFlixMenu")}</Link>
				</NavDropdown.Item>
				<NavDropdown.Item target="_self" alt="">
					<Link onClick={() => { if (soundsEnabled) { play() }; setExpanded(false) }} to="./../meet-case" className="nav-cases" target="_self" >{t("menu.meetMenu")}</Link>
				</NavDropdown.Item>
				<NavDropdown.Item target="_self" alt="">
					<Link onClick={() => { if (soundsEnabled) { play() }; setExpanded(false) }} to="./../owrite-case" className="nav-cases" target="_self" >{t("menu.owriteMenu")}</Link>
				</NavDropdown.Item>
				<NavDropdown.Item target="_self" alt="">
					<Link onClick={() => { if (soundsEnabled) { play() }; setExpanded(false) }} to="./../pokemon-case" className="nav-cases" target="_self" >{t("menu.pokemonMenu")}</Link>
				</NavDropdown.Item>
				<NavDropdown.Item target="_self" alt="">
					<Link onClick={() => { if (soundsEnabled) { play() }; setExpanded(false) }} to="./../portfolio-case" className="nav-cases" target="_self" >{t("menu.portfolioMenu")}</Link>
				</NavDropdown.Item>

			</NavDropdown>
		)
	}


	const ClickNavResumes = () => {
		const [play] = useSound(Click);
		const { soundsEnabled } = useSoundSettings();

		return (
			<NavDropdown className="cv-drop" onClick={() => { showMenuDownloadLinks(); if (soundsEnabled) { play() } }} title={t("menu.resumeMenu")} id="collapsible-nav-dropdown">



				<NavDropdown.Item className="text-center cv-menu-container" title={t("aboutCvDeTitle")} href={Lebenslauf} download="Yevhenii-Airapetian-Lebenslauf-DE" target="_blank" rel="noopener noreferrer">
					<img className="flags" alt="An icon showing the German flag" src="https://hatscripts.github.io/circle-flags/flags/de.svg" width="28" />
					<Link onClick={() => { if (soundsEnabled) { play() }; setExpanded(false) }} to={Lebenslauf} title="Download the resume version in German" className="download-de" target="_blank" ></Link>
				</NavDropdown.Item>
				<NavDropdown.Item className="text-center cv-menu-container" title={t("aboutCvEnTitle")} href={CV} download="Yevhenii-Airapetian-CV-EN" target="_blank" rel="noopener noreferrer">
					<img className="flags" alt="An icon showing the USA flag" src="https://hatscripts.github.io/circle-flags/flags/us.svg" width="28" />
					<Link onClick={() => { if (soundsEnabled) { play() }; setExpanded(false) }} to={CV} title="Download the resume version in English" className="download-en" target="_blank" ></Link>
				</NavDropdown.Item>
				

			</NavDropdown>
		)
	}
	const ClickTerms = () => {
		const [play] = useSound(Click);
		const { soundsEnabled } = useSoundSettings();

		return (
			<NavDropdown onClick={() => { if (soundsEnabled) { play() } }} className="cases-nav-container mr-2 " title={t("menu.policiesMenu")} id="collapsible-nav-dropdown">



				<NavDropdown.Item href="https://www.freeprivacypolicy.com/live/13aaa5dd-c830-46ce-8e8a-010efe1a66f1" target="_blank" alt="">
					<Link onClick={() => { if (soundsEnabled) { play() }; setExpanded(false) }} to={"https://www.freeprivacypolicy.com/live/13aaa5dd-c830-46ce-8e8a-010efe1a66f1"} className="nav-cases" target="_blank" >{t("menu.cookies")}</Link>
				</NavDropdown.Item>
				<NavDropdown.Item href="https://www.freeprivacypolicy.com/live/c361241a-8f0b-4be3-8d44-56ba30ba476a" target="_blank" alt="">
					<Link onClick={() => { if (soundsEnabled) { play() }; setExpanded(false) }} to={"https://www.freeprivacypolicy.com/live/c361241a-8f0b-4be3-8d44-56ba30ba476a"} className="nav-cases" target="_blank" >{t("menu.privacy")}</Link>
				</NavDropdown.Item>


			</NavDropdown>
		)
	}

	const ClickThemeDark = () => {
		const [play] = useSound(Click);
		const { soundsEnabled } = useSoundSettings();

		return <button
			title={t("themeSwitcherLightHint")}

			className="toggle_btn w-100" onClick={() => { handleThemeChange("light"); if (soundsEnabled) { play() }; handleShowLightModal(); setExpanded(false) }}>

			<FontAwesomeIcon className="sun"
				title={t("themeSwitcherLightHint")}
				icon={faSun} style={{ color: "gold" }} />
		</button>
	};


	const ClickThemeLight = () => {
		const [play] = useSound(Click);
		const { soundsEnabled } = useSoundSettings();

		return <button title={t("themeSwitcherDarkHint")} className="toggle_btn w-100" onClick={() => { handleThemeChange("dark"); if (soundsEnabled) { play() }; handleShowDarkModal(); setExpanded(false) }}>
			<FontAwesomeIcon className="moon"
				title={t("themeSwitcherDarkHint")}
				icon={faMoon} style={{ color: "#000000" }} />
		</button>
	};

	const ClickThemeOld = () => {
		const [play] = useSound(Click);
		const { soundsEnabled } = useSoundSettings();

		return <button
			title={t("themeSwitcherGlitchHint")}

			className="toggle_btn w-100" onClick={() => { if (soundsEnabled) { play() }; handleThemeChange("old"); handleShowOldModal(); setExpanded(false) }}>
			<FontAwesomeIcon className="moon bolt"
				title={t("themeSwitcherGlitchHint")}
				icon={faBolt} style={{ color: "#74CoFC" }} />
		</button>
	};

	const ClickThemeReducedMotion = () => {
		const [play] = useSound(Click);
		const { soundsEnabled } = useSoundSettings();

		return <button
			title={t("themeSwitcherMotionHint")}

			className="toggle_btn w-100" onClick={() => { if (soundsEnabled) { play() }; handleThemeChange("reduced-motion"); handleShowMotionModal(); setExpanded(false) }}>
			<FontAwesomeIcon className="moon reduced-motion"
				title={t("themeSwitcherMotionHint")}
				icon={faPersonRunning} style={{ color: "#74CoFC" }} />
		</button>
	};

	const ClickThemeSystem = () => {
		const [play] = useSound(Click);
		const { soundsEnabled } = useSoundSettings();

		return <button
			title={t("themeSwitcherSystemHint")}

			className="toggle_btn w-100" onClick={() => { if (soundsEnabled) { play() }; handleThemeChange("system"); handleShowSystemModal(); setExpanded(false) }}>
			<FontAwesomeIcon className="moon system"
				title={t("themeSwitcherSystemHint")}
				icon={faDesktop} style={{ color: "#74CoFC" }} />
		</button>
	};

	const ClickLanguage = () => {
		const [play] = useSound(Click);
		const { soundsEnabled } = useSoundSettings();

		return <div className="lang-wrapper">
			<select title={t("langHint")} className="lang-choose" onChange={handleChangeLocale} onClick={() => { if (soundsEnabled) { play() } }} value={language}>
				{languages.map(({ name, code }) => (
					<option className="lang-option-text" key={code} value={code}>🌏︎ {name}</option>
				))}
			</select>
			<div className="custom-dropdown"></div> {/* Fake styled option */}
		</div>
	};



	// const ClickBell = () => {
	// 	const { soundsEnabled } = useSoundSettings();

	// 	const [play] = useSound(Click);
	// 	return <div>
	// 		{currentTableData.map(item => (
	// 			<div key={item.id}>

	// 				<button title={t("notificationHint")} className="notification-button pl-4" onClick={() => { if (soundsEnabled) { play(); } setVisible(!visible) }}>
	// 					{visible ? <FontAwesomeIcon className="bell-calm" icon={faBell} size="lg" style={{ color: "#529fcc", }} /> : <FontAwesomeIcon className="bell-active" icon={faBell} shake size="lg" style={{ color: "#ffffff", "--fa-animation-iteration-count": "1" }} />}
	// 				</button>

	// 				{visible && <div className="notification"><div><div title={t("notificationCloseTitle")} className="close-notification-container"><ClickButton  ><span className="text-primary"></span></ClickButton></div></div><div className="new-info">{t("whatsNewInfo")}</div>

	// 					<Link className="more-info-dialog-links" onClick={() => { setVisible(!visible) }} to={"./../portfolio-case"}  >
	// 						<span className="notification-more-link">{t("whatsNewLink")}</span></Link>
	// 					<div className="new-info">{t("whatsNewInfo2")}</div>
	// 					<Link className="more-info-dialog-links" onClick={() => { setVisible(!visible) }} to={"./../blog"}>
	// 						<span className="notification-more-link">{t("whatsNewLink2")}</span></Link>

	// 				</div>

	// 				}
	// 			</div>
	// 		))}
	// 	</div>
	// };
	const [visible, setVisible] = useState(false);
	const currentTableData = [
		{ id: 1, title: 'What\'s new: the app moved to React, is localized, and has a theme toggler. Read more: ' },
		// { id: 2, title: 'BBB' },
		// { id: 3, title: 'CCC' }
	];
	// const [showNewVisitorModal, setShowNewVisitorModal] = useState(true);
	const [showDarkModal, setShowDarkModal] = useState(false);
	const [showSoundEnabledModal, setShowSoundEnabledModal] = useState(false);
	const [showSoundDisabledModal, setShowSoundDisabledModal] = useState(false);
	const [showSystemModal, setShowSystemModal] = useState(false);
	const [showMotionModal, setShowMotionModal] = useState(false);
	const [showOldModal, setShowOldModal] = useState(false);
	const [showLightModal, setShowLightModal] = useState(false);
	const handleShowLightModal = () => setShowLightModal(true);
	const handleShowSoundEnabledModal = () => setShowSoundEnabledModal(true);
	const handleShowSoundDisabledModal = () => setShowSoundDisabledModal(true);
	const handleShowDarkModal = () => setShowDarkModal(true);
	const handleShowSystemModal = () => setShowSystemModal(true);
	const handleShowMotionModal = () => setShowMotionModal(true);
	const handleShowOldModal = () => setShowOldModal(true);
	//   const handleCloseNewVisitorModal = () => setShowNewVisitorModal(false);
	const handleCloseLightModal = () => setShowLightModal(false);
	const handleCloseSoundEnabledModal = () => setShowSoundEnabledModal(false);
	const handleCloseSoundDisabledModal = () => setShowSoundDisabledModal(false);
	const handleCloseDarkModal = () => setShowDarkModal(false);
	const handleCloseSystemModal = () => setShowSystemModal(false);
	const handleCloseMotionModal = () => setShowMotionModal(false);
	const handleCloseOldModal = () => setShowOldModal(false);

	const [theme, setTheme] = useDarkMode();
	const handleThemeChange = (newTheme) => { setTheme(newTheme); };
	const { t, i18n } = useTranslation();
	const [expanded, setExpanded] = useState(false);



	function showMenuDownloadLinks() {
		let linkDE = $('.download-menu-de');
		let linkEN = $('.download-menu-en');
		let linkUK = $('.download-menu-uk');
		let caret = $('.resume-caret');
		linkDE.fadeToggle();
		linkEN.fadeToggle();
		linkUK.fadeToggle();
		caret.fadeToggle();


	}


	function closeMenuDownloadLinks() {
		let linkDE = $('.download-menu-de');
		let linkEN = $('.download-menu-en');
		let linkUK = $('.download-menu-uk');
		let caret = $('.resume-caret');
		linkDE.fadeOut();
		linkEN.fadeOut();
		linkUK.fadeOut();
		caret.fadeOut();


	}
	const languages = [
		{ name: "EN", code: "en" },
		{ name: "DE", code: "de" },
		{ name: "ES", code: "es" },
		{ name: "PT", code: "pt" },
		{ name: "IT", code: "it" },
		{ name: "FR", code: "fr" },
		{ name: "UK", code: "uk" },
		{ name: "RU", code: "ru" },
		{ name: "MK", code: "mk" },
		{ name: "PL", code: "pl" },
		{ name: "日本語", code: "ja" },
		{ name: "中文", code: "zh" },
		{ name: "한국어", code: "ko_KR" },
		{ name: "TR", code: "tr" },
		{ name: "العربية", code: "ar", dir: "rtl" }

	];
	const currentLocale = Cookies.get("i18next") || "en";
	const currentLangObj = languages.find((lang) => lang.code === currentLocale);

	const [language, setLanguage] = useState(currentLocale);

	const handleChangeLocale = (e) => {
		const lang = e.target.value;
		setLanguage(lang);
		i18n.changeLanguage(lang);
	};

	const location = useLocation();

	useEffect(() => {

		// document.body.dir = currentLangObj.dir || 'ltr';
		document.body.dir = 'ltr'||'rtl';
	}, [currentLangObj, t]);


	return (
		<>
			<Navbar expanded={expanded} onClick={() => { closeMenuDownloadLinks() }} className="page-header" expand="xl" id="navigation">
				<Container className="navigation">
					<ScrollToAnchor />
					<Navbar.Brand className="p-2 brand" as={Link} to="/" expand="lg">
						<Image onClick={() => setExpanded(false)} className="img-responsive logo"
							alt={t("logoAlt")}
							src={"../../logo.svg"} />



					</Navbar.Brand>
					<Navbar.Toggle id="tgl" onClick={() => setExpanded(!expanded)}>

						{expanded ? <svg className="nav-ico-x" width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <rect x="4" y="11" width="16" height="2" transform="rotate(45 12 12)" fill="currentColor" className="line1" /> <rect x="4" y="11" width="16" height="2" transform="rotate(-45 12 12)" fill="currentColor" className="line2" /> </svg> : <svg className="nav-ico-hamb" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <rect y="4" width="24" height="2" fill="currentColor" className="line1" /> <rect y="11" width="24" height="2" fill="currentColor" className="line2" /> <rect y="18" width="24" height="2" fill="currentColor" className="line3" /> </svg>}
					</Navbar.Toggle>
					<Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
						<Nav>

							<ClickMenuPrimaryLinks />


							<ClickCases />


							<ClickMenuAdditionalLinks />
							<ClickNavResumes />

							<ClickTerms />


							<div className="switcher pl-3 lang-active">

								<ClickLanguage />
							</div>

							<Themes />


							{/* <Nav.Link className="bell-btn text-light pe-4">
								<ClickBell />
							</Nav.Link> */}

							<SoundToggleButton />


						</Nav>

					</Navbar.Collapse>
				</Container>
			</Navbar>
			<Modal

				className="favorite-modal" show={showDarkModal} onHide={handleCloseDarkModal}>
				<Modal.Header closeButton>
				</Modal.Header>
				<Modal.Body className="text-dark bg-white dark-modal-body"><FontAwesomeIcon className="pr-2" icon={faCircleInfo} fade style={{ color: "#529fcc", }} size="lg" />{t("darkModalMessage")}</Modal.Body>

				<Button title={t("modalHint")} className="got-it-button text-dark bg-white dark-modal-button" onClick={handleCloseDarkModal}>{t("modalConfirm")}</Button>

			</Modal>

			<Modal

				className="favorite-modal" show={showSoundEnabledModal} onHide={handleCloseSoundEnabledModal}>
				<Modal.Header closeButton>
				</Modal.Header>
				<Modal.Body className="text-dark bg-white dark-modal-body"><FontAwesomeIcon className="pr-2" icon={faCircleInfo} fade style={{ color: "#529fcc", }} size="lg" />{t("modalMuted")}</Modal.Body>

				<Button title={t("modalHint")} className="got-it-button text-dark bg-white dark-modal-button" onClick={handleCloseSoundEnabledModal}>{t("modalConfirm")}</Button>

			</Modal>

			<Modal

				className="favorite-modal" show={showSoundDisabledModal} onHide={handleCloseSoundDisabledModal}>
				<Modal.Header closeButton>
				</Modal.Header>
				<Modal.Body className="text-dark bg-white dark-modal-body"><FontAwesomeIcon className="pr-2" icon={faCircleInfo} fade style={{ color: "#529fcc", }} size="lg" />{t("modalUnmuted")}</Modal.Body>

				<Button title={t("modalHint")} className="got-it-button text-dark bg-white dark-modal-button" onClick={handleCloseSoundDisabledModal}>{t("modalConfirm")}</Button>

			</Modal>

			<Modal

				className="favorite-modal" show={showLightModal} onHide={handleCloseLightModal}>
				<Modal.Header closeButton>
				</Modal.Header>
				<Modal.Body className="text-dark bg-white"><FontAwesomeIcon className="pr-2" icon={faCircleInfo} fade style={{ color: "#529fcc", }} size="lg" />{t("lightModalMessage")}

				</Modal.Body>

				<Button title={t("modalHint")} className="got-it-button light-modal-button" onClick={handleCloseLightModal}>{t("modalConfirm")}</Button>
			</Modal>

			<Modal

				className="favorite-modal" show={showOldModal} onHide={handleCloseOldModal}>
				<Modal.Header closeButton>
				</Modal.Header>
				<Modal.Body className="text-dark bg-white"><FontAwesomeIcon className="pr-2" icon={faCircleInfo} fade style={{ color: "#529fcc", }} size="lg" />{t("glitchModalMessage")}

				</Modal.Body>

				<Button title={t("modalHint")} className="got-it-button light-modal-button" onClick={handleCloseOldModal}>{t("modalConfirm")}</Button>
			</Modal>

			<Modal

				className="favorite-modal system-modal" show={showSystemModal} onHide={handleCloseSystemModal}>
				<Modal.Header closeButton>
				</Modal.Header>
				<Modal.Body className="system-modal-favorite"><FontAwesomeIcon className="pr-2" icon={faCircleInfo} fade style={{ color: "#529fcc", }} size="lg" />{t("systemModalMessage")}

				</Modal.Body>

				<Button title={t("modalHint")} className="got-it-button light-modal-button" onClick={handleCloseSystemModal}>{t("modalConfirm")}</Button>
			</Modal>

			<Modal

				className="favorite-modal motion-modal-favorite" show={showMotionModal} onHide={handleCloseMotionModal}>
				<Modal.Header closeButton>
				</Modal.Header>
				<Modal.Body className="motion-modal-body text-dark pr-5"><FontAwesomeIcon className="pr-2" icon={faCircleInfo} fade style={{ color: "#529fcc", }} size="lg" />{t("motionModalMessage")}

				</Modal.Body>

				<Button title={t("modalHint")} className="got-it-button light-modal-button" onClick={handleCloseMotionModal}>{t("modalConfirm")}</Button>
			</Modal>

		</>
	);
};
